import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledTerm = styled.dd `
    font-size: 15px;
    font-weight: 400;
    color: #8d8d8d;
`;
const DataTerm = ({ children }) => (_jsx(StyledTerm, { children: children }));
export default DataTerm;
